module.exports = __webpack_public_path__ + "img/single-arrow.eec0ced5.svg";